import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage} from "../../panels/BasePanelPage";
import {Messages} from "../../../../Messages";
import {LoadingSpinner} from "../../../../ui/LoadingSpinner";
import {Router} from "../../../../../stem-core/src/ui/Router";
import {MerchantButton} from "../../../../common/MerchantButton";
import {apiDeleteAddress, UserAddressStore} from "../../../../../client/state/UserAddressStore";
import {Controller} from "../../../Controller";
import {MessageElement} from "../../../../widget/ui/MessageElement";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {autoredraw} from "../../../../../stem-core/src/decorators/AutoRedraw";
import {InlineUserDashboardPanelStyle} from "./InlineUserDashboardPanelStyle";
import {Toast} from "../../../../ui/Toast.jsx";


@autoredraw(UserAddressStore)
@registerStyle(InlineUserDashboardPanelStyle)
export class InlineUserDashboardRemoveAddressPanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.removeAddress,
        };
    }

    async removeAddress() {
        LoadingSpinner.show();
        try {
            await apiDeleteAddress(Controller.address.selectedAddress.id);
            Router.back();
            Toast.showSuccess(Messages.addressRemoved);
        } catch (error) {
            Toast.showError(error);
        } finally {
            LoadingSpinner.hide();
        }
    }

    render() {
        const {styleSheet} = this;

        return [
            <MessageElement message={Messages.deleteAddressDescription(Controller.address.selectedAddress.toString())}/>,
            <MerchantButton className={styleSheet.button} label={Messages.remove} onClick={() => this.removeAddress()}/>,
            <div className={styleSheet.center}>
                <div className={styleSheet.secondaryButton} onClick={() => Router.back()}>
                    {Messages.cancel}
                </div>
            </div>
        ];
    }
}
